<template>
  <div class="subscribe-container">
    <div class="page-header">
      <h2>预约申请信息列表</h2>
    </div>

    <!-- 筛选条件 -->
    <div class="filter-container">
      <el-form :inline="true" :model="filterForm" class="filter-form">
        <el-form-item label="所属行业">
          <el-select
            v-model="filterForm.industry"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in industryList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="申请时间">
          <el-date-picker
            v-model="filterForm.dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="handleFilter">筛选</el-button>
          <el-button @click="resetFilter">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 申请列表 -->
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      max-height="600px"
      v-loading="loading"
      :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
    >
      <el-table-column
        type="index"
        label="序号"
        width="80"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="productName"
        label="产品信息"
        min-width="180"
      ></el-table-column>
      <el-table-column
        prop="phone"
        label="申请用户手机号"
        min-width="180"
      ></el-table-column>
      <el-table-column
        prop="companyName"
        label="企业名称"
        min-width="180"
      ></el-table-column>
      <el-table-column
        prop="contactName"
        label="联系人姓名"
        width="120"
      ></el-table-column>
      <el-table-column
        prop="contactPosition"
        label="联系人职务"
        width="120"
      ></el-table-column>
      <el-table-column
        prop="contactPhone"
        label="联系人手机号"
        width="140"
      ></el-table-column>
      <el-table-column
        prop="hasPatent"
        label="是否有专利权"
        width="120"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag :type="scope.row.hasPatent ? 'success' : 'info'">
            {{ scope.row.hasPatent ? "是" : "否" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="fundingAmount"
        label="资金需求(万元)"
        width="140"
        align="right"
      ></el-table-column>
      <el-table-column
        prop="industry"
        :formatter="formatterIndustry"
        label="所属行业"
        width="120"
      ></el-table-column>
      <el-table-column
        prop="employeeCount"
        label="从业人数"
        width="100"
        align="right"
      ></el-table-column>
      <el-table-column
        prop="annualRevenue"
        label="年营业收入(万元)"
        width="150"
        align="right"
      ></el-table-column>
      <el-table-column
        prop="totalAssets"
        label="资产总额(万元)"
        width="150"
        align="right"
      ></el-table-column>
      <el-table-column
        prop="serviceName"
        label="意向服务网点"
        width="150"
      ></el-table-column>
      <el-table-column
        prop="referrerCode"
        label="推荐人号"
        width="150"
      ></el-table-column>
      <el-table-column
        prop="create_time"
        label="申请时间"
        width="180"
      ></el-table-column>
      <el-table-column label="操作" width="180" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleView(scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <!-- 详情对话框 -->
    <el-dialog title="申请详情" :visible.sync="detailVisible" width="60%">
      <div class="detail-container" v-if="currentItem">
        <div class="detail-header">
          <h3>{{ currentItem.productName }}</h3>
          <el-tag>{{ formatterIndustry(currentItem) }}</el-tag>
        </div>
        <el-divider content-position="left">基本信息</el-divider>
        <el-descriptions :column="2" border>
          <el-descriptions-item label="联系人姓名">{{
            currentItem.contactName
          }}</el-descriptions-item>
          <el-descriptions-item label="联系人职务">{{
            currentItem.contactPosition
          }}</el-descriptions-item>
          <el-descriptions-item label="联系人手机号">{{
            currentItem.contactPhone
          }}</el-descriptions-item>
          <el-descriptions-item label="是否有专利权">
            <el-tag
              size="small"
              :type="currentItem.hasPatent ? 'success' : 'info'"
            >
              {{ currentItem.hasPatent ? "是" : "否" }}
            </el-tag>
          </el-descriptions-item>
        </el-descriptions>

        <el-divider content-position="left">企业情况</el-divider>
        <el-descriptions :column="2" border>
          <el-descriptions-item label="企业名称"
            >{{ currentItem.companyName }}</el-descriptions-item
          >
          <el-descriptions-item label="资金需求"
            >{{ currentItem.fundingAmount }} 万元</el-descriptions-item
          >
          <el-descriptions-item label="从业人数"
            >{{ currentItem.employeeCount }} 人</el-descriptions-item
          >
          <el-descriptions-item label="年营业收入"
            >{{ currentItem.annualRevenue }} 万元</el-descriptions-item
          >
          <el-descriptions-item label="资产总额"
            >{{ currentItem.totalAssets }} 万元</el-descriptions-item
          >
          <el-descriptions-item label="意向服务网点">{{
            currentItem.serviceName
          }}</el-descriptions-item>
          <el-descriptions-item label="推荐人号"
            >{{ currentItem.referrerCode || '暂无' }}</el-descriptions-item
          >
          <el-descriptions-item label="申请时间">{{
            currentItem.create_time
          }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getInfo } from "@/api";
export default {
  name: "Subscribe",
  data() {
    return {
      // 筛选表单数据
      filterForm: {
        industry: "", // 行业筛选值
        dateRange: [], // 日期范围筛选值
      },

      // 行业列表数据
      industryList: [
        {
          name: "农、林、牧、渔业", // 行业名称
          id: "1", // 行业ID
        },
        {
          name: "采矿业；制造业",
          id: "2",
        },
        {
          name: "电力、热力、燃气及水生产和供应业",
          id: "3",
        },
        {
          name: "建筑业",
          id: "4",
        },
        {
          name: "批发和零售业",
          id: "5",
        },
        {
          name: "交通运输、仓储和邮政业",
          id: "6",
        },
        {
          name: "住宿和餐饮业",
          id: "7",
        },
        {
          name: "信息传输、软件和信息技术服务业",
          id: "8",
        },
        {
          name: "金融业",
          id: "9",
        },
        {
          name: "房地产业",
          id: "10",
        },
        {
          name: "租赁和商务服务业",
          id: "11",
        },
        {
          name: "科学研究和技术服务业",
          id: "12",
        },
        {
          name: "水利、环境和公共设施管理业",
          id: "13",
        },
        {
          name: "居民服务、修理和其他服务业",
          id: "14",
        },
        {
          name: "教育业",
          id: "15",
        },
        {
          name: "卫生和社会工作",
          id: "16",
        },
        {
          name: "文化、体育和娱乐业",
          id: "17",
        },
        {
          name: "公共管理、社会保障和社会组织",
          id: "18",
        },
      ],

      // 表格数据相关
      tableData: [], // 表格数据列表
      loading: false, // 加载状态标志
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示条数
      total: 0, // 总记录数

      // 详情对话框相关
      detailVisible: false, // 详情对话框显示状态
      currentItem: null, // 当前查看的申请详情
    };
  },
  // 组件创建时执行
  created() {
    this.getList(); // 获取申请列表数据
  },
  methods: {
    // 获取申请列表数据
    getList() {
      this.loading = true; // 显示加载状态
      let condition = {}; // 初始化查询条件对象

      // 添加行业筛选条件
      if (this.filterForm.industry) {
        condition.industry = this.filterForm.industry;
      }

      // 调用API接口获取数据
      getInfo({
        model: "subscribe", // 模型名称
        condition, // 查询条件
        page: this.currentPage, // 当前页码
        pagesize: this.pageSize, // 每页条数
      }).then((res) => {
        if (res.status == 200) {
          this.tableData = res.data.data; // 设置表格数据
          this.total = res.data.page_info.total_size; // 设置总记录数
          this.loading = false; // 隐藏加载状态
        }
      });
    },

    // 筛选按钮点击处理
    handleFilter() {
      this.currentPage = 1; // 重置为第一页
      this.getList(); // 重新获取列表数据
    },

    // 重置筛选条件
    resetFilter() {
      // 重置筛选表单数据
      this.filterForm = {
        industry: "",
        dateRange: [],
      };
      this.getList(); // 重新获取列表数据
    },

    // 分页处理函数
    handleSizeChange(val) {
      this.pageSize = val; // 更新每页显示条数
      this.getList(); // 重新获取列表数据
    },
    handleCurrentChange(val) {
      this.currentPage = val; // 更新当前页码
      this.getList(); // 重新获取列表数据
    },

    // 查看详情
    handleView(row) {
      this.currentItem = row; // 设置当前查看的申请项
      this.detailVisible = true; // 显示详情对话框
    },

    // 格式化行业显示
    formatterIndustry(row, column) {
      let industry = row.industry; // 获取行业ID
      let industryList = this.industryList; // 获取行业列表
      // 查找匹配的行业项
      let industryItem = industryList.find((item) => {
        return item.id == industry;
      });
      return industryItem.name; // 返回行业名称
    },
  },
};
</script>

<style scoped>
.subscribe-container {
  padding: 20px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
}

.page-header h2 {
  font-size: 22px;
  color: #303133;
  margin: 0;
  font-weight: 600;
}

.filter-container {
  background-color: #fff;
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.filter-form {
  display: flex;
  flex-wrap: wrap;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

/* 表格样式优化 */
.el-table {
  border-radius: 4px;
  overflow: hidden;
}

/* 详情对话框样式 */
.detail-container {
  padding: 10px;
}

.product-name {
  font-size: 24px;
  color: #409eff;
  font-weight: bold;
}

.detail-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.detail-header h3 {
  margin: 0;
  font-size: 20px;
  color: #303133;
  margin-right: 10px;
}

/* 标签样式 */
/deep/ .el-tag--success {
  background-color: #f0f9eb;
  border-color: #e1f3d8;
  color: #67c23a;
}

/deep/ .el-tag--info {
  background-color: #f4f4f5;
  border-color: #e9e9eb;
  color: #909399;
}

/* 响应式调整 */
@media screen and (max-width: 768px) {
  .page-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .header-actions {
    margin-top: 15px;
    width: 100%;
  }

  .search-input {
    width: 100%;
    margin-right: 0;
    margin-bottom: 10px;
  }

  .filter-form .el-form-item {
    margin-right: 0;
    width: 100%;
  }

  .el-date-picker {
    width: 100%;
  }
}
</style>